import { css } from 'styled-components';
import { chipVariants } from './chipColors';
import type { ChipProps } from './types';

const baseStyling = css`
    &:has(:checked) {
        font-weight: bold;
    }
`;

export const chipVariantStyling = css<{
    $variant: ChipProps['variant'];
}>`
    ${baseStyling}

    ${({ $variant }) =>
        $variant &&
        css`
            box-shadow: inset 0 0 0 1px ${chipVariants[$variant].borderColor};
            color: ${chipVariants[$variant].fontColor};
            background-color: transparent;
         
            &:has(:checked) {
                box-shadow: inset 0 0 0 2px ${chipVariants[$variant].checked.borderColor || chipVariants[$variant].borderColor};
                color: ${chipVariants[$variant].checked.fontColor || chipVariants[$variant].fontColor};
            }

            &:has(:disabled) {
                box-shadow: inset 0 0 0 1px ${chipVariants[$variant].disabled.borderColor || chipVariants[$variant].borderColor};
                color: ${chipVariants[$variant].disabled.fontColor || chipVariants[$variant].fontColor};
            }

            &:has(:disabled:checked) {
                box-shadow: inset 0 0 0 2px ${chipVariants[$variant].disabled.borderColor || chipVariants[$variant].borderColor};
            }

            // background color logic
            ${() =>
                chipVariants[$variant].backgroundColor &&
                css`
                    background-color: ${chipVariants[$variant].backgroundColor};

                    &:has(:checked) {
                        background-color: ${chipVariants[$variant].checked.backgroundColor || chipVariants[$variant].backgroundColor};
                    }

                    &:has(:disabled) {
                        background-color: ${chipVariants[$variant].disabled.backgroundColor || chipVariants[$variant].backgroundColor};
                    }
                `}
        `}
`;
